import { FullScreenLoader } from '@/features/ui/components/FullScreenLoader';
import FormBuilderHeader from './FormBuilderHeader';
import FieldMappingTestModal from './validation/FieldMappingTestModal';
import GridLevelValidationModal from './validation/GridLevelValidationModal';
import DuplicateMappingNameModal from './validation/DuplicateMappingNameModal';
import { useMappingsStore } from '../store/mappings.store';
import { useFormBuilder } from '../hooks/form-builder.hook';
import FormStructureNavigator from './FormStructureNavigator';
import MappingEditorPane from './MappingEditorPane';

const FormBuilder = () => {
  const {
    // State
    gridLevelValidationModal,
    dashboardInitialized,
    testResults,

    // Handlers
    handleCreateNewMapping,
    handleSaveCurrent,
    handleCloseGridLevelValidation,
    closeTestResults,
  } = useFormBuilder();
  const { duplicateNameModalOpen, closeDuplicateNameModal } = useMappingsStore();

  if (!dashboardInitialized) {
    return <FullScreenLoader message="Loading form builder..." showOverlay={false} />;
  }

  return (
    <>
      <div className="h-full flex flex-col bg-gray-50 overflow-hidden">
        <FormBuilderHeader onSave={handleSaveCurrent} onCreateNewMapping={handleCreateNewMapping} />

        {/* Main Content - flex-1 fills remaining height, overflow-hidden prevents page scroll */}
        <main className="flex flex-1 overflow-hidden">
          {/* Middle pane: hierarchical form structure navigator */}
          <FormStructureNavigator />
          {/* Right pane: single-field mapping editor */}
          <MappingEditorPane />
        </main>
      </div>
      <FieldMappingTestModal
        isOpen={testResults.isOpen}
        onClose={closeTestResults}
        results={testResults.results}
        totalMappings={testResults.totalMappings}
        validMappings={testResults.validMappings}
        inProgress={testResults.inProgress}
        saveCompleted={testResults.saveCompleted}
      />
      <GridLevelValidationModal
        isOpen={gridLevelValidationModal.isOpen}
        onClose={handleCloseGridLevelValidation}
        errors={gridLevelValidationModal.errors}
      />
      <DuplicateMappingNameModal
        isOpen={duplicateNameModalOpen}
        onClose={closeDuplicateNameModal}
      />
    </>
  );
};

export default FormBuilder;
